import React, { useEffect, useState } from "react";
import Resourcebanner from "main/assets/images/Images/Resources-Images/resources-banner.png";
import commingsoon from "main/assets/images/Images/Resources-Images/opening-soon.png";
import { MainPageHeader } from "main/components";

import content from "main/helpers/contentHelper.json";

type Props = {};

const Resources = (props: Props) => {
  const [data, setData] = useState<any>(undefined);

  useEffect(() => {
    window.scrollTo(0, 0);
    setData(content);
  }, []);

  return (
    <>
      <div>
        <MainPageHeader
          backgroundImage={Resourcebanner}
          heading={data ? data?.resource?.headerTitle : ""}
          description={data ? data?.resource?.headerDesc : ""}
          descriptionClass='text-white'
          mainclassName="hx-380"
        />
      </div>
      <div className="d-flex justify-content-center align-items-center mb-500">
        <img src={commingsoon} alt="opening soon" />
      </div>
    </>
  );
};

export default Resources;
